export default "__VITE_ASSET__DoEPiukF__"